import { Tag } from "@vapor/react-custom";
import { useTheme } from "@vapor/react-material";
import { useTranslation } from "react-i18next";
import { TaxSubmissionStatus } from "../../../core/dtos/TaxSubmissionStatus";
import { getColorByTaxSubmissionStatus } from "../../../core/utils/getColorByTaxSubmissionStatus";

interface TaxSubmissionStatusChipProps {
    plural?: boolean;
    status: TaxSubmissionStatus;
    variant?: "ghost" | "default" | "standard";
    forceColorByStatus?: TaxSubmissionStatus;
}
export const TaxSubmissionStatusChip: React.FC<
    TaxSubmissionStatusChipProps
> = ({
    plural = false,
    status,
    variant = "standard",
    forceColorByStatus = undefined,
}): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Tag
            label={t(
                `components.tax_submission_status_chip.status.${
                    plural ? "plural." : ""
                }${status?.toLowerCase() ?? "not_available"}`,
            )}
            type={
                getColorByTaxSubmissionStatus(
                    forceColorByStatus || status,
                    theme,
                ).vaporColor
            }
            variant={variant}
        ></Tag>
    );
};
